import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "m6.999 8.055-5.074 5.073a.73.73 0 0 1-.522.213.7.7 0 0 1-.531-.213.72.72 0 0 1-.218-.527q0-.31.218-.526L5.945 7 .872 1.928a.73.73 0 0 1-.213-.522.7.7 0 0 1 .213-.531.72.72 0 0 1 .527-.218q.31 0 .526.218L7 5.948 12.072.875a.73.73 0 0 1 .522-.213.7.7 0 0 1 .531.213q.218.216.218.526a.72.72 0 0 1-.218.527L8.052 7.001l5.073 5.074q.209.207.213.522a.7.7 0 0 1-.213.531.72.72 0 0 1-.527.218.72.72 0 0 1-.526-.218z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }